import { useContext, useState } from "react";
import { BsSearch } from "react-icons/bs";
import { useLocation } from "react-router-dom";

import Table from "components/accountant-table/accountant-table.component";
import FilterModal from "./components/filter-modal/filter-modal.component";

import { ClientsContext } from "src/contexts/clients.context";

import "./clients.style.scss";
import NewClientModal from "components/new-client-modal/new-client-modal.component";
import { useMemo } from "react";
import {
	ACTIVATION_TYPES,
	ARCHIVE_PERIODS,
	CLIENT_TYPES,
	SAFE_LOCKING_PERIODS,
	SUBSCRIPTIONS,
} from "utils/lists.utils";

const FILTER_CATEGORIES = {
	clientType: {
		key: "clientType",
		label: "Client Type",
		choices: [...CLIENT_TYPES, "PP"],
	},
	subscription: {
		key: "subscription",
		label: "Subscription",
		choices: SUBSCRIPTIONS,
	},
	archivePeriod: {
		key: "archivePeriod",
		label: "Archive Period",
		choices: ARCHIVE_PERIODS,
	},
	safeLockingPeriod: {
		key: "safeLockingPeriod",
		label: "Safe Locking Period",
		choices: SAFE_LOCKING_PERIODS,
	},
	liveChat: { key: "liveChat", label: "Live Chat", choices: ACTIVATION_TYPES },
	mobile: { key: "mobile", label: "Mobile App", choices: ACTIVATION_TYPES },
};

const filterTemplate = {
	clientType: [], // for Client Type
	subscription: [], // for Subscription
	archivePeriod: [], // for Archive Period
	safeLockingPeriod: [], // for Safe Locking PeriodSafe Locking Period
	liveChat: [], // for Live Chat
	mobile: [], // for Mobile App
};

const checkIncludes = (array = [], item = "") => {
	return array.includes(item);
};

const fillFilterArrayIfEmpty = (filterArray, fullList) => {
	if (filterArray.length === 0) {
		const filledArray = Array.from(Array(fullList.length).keys()); // [0, 1, 2 ...]
		return filledArray;
	}
	return filterArray;
};

const Clients = () => {
	const { clients } = useContext(ClientsContext);
	const { state } = useLocation();
	const initialIndex = state?.initialIndex;

	const [newClientModalVisible, setNewClientModalVisible] = useState(false);
	const [filterModalVisible, setFilterModalVisible] = useState(false);
	const [filters, setFilters] = useState(null);
	const [searchText, setSearchText] = useState(["", false]); // [text, is search button clicked]

	const filteredClients = useMemo(() => {
		if (!filters || Object.keys(filters).length === 0) return clients;

		const organizedFilters = filterTemplate;

		Object.keys(filters).forEach((key, index) => {
			organizedFilters[key] = fillFilterArrayIfEmpty(filters[key], FILTER_CATEGORIES[key].choices);
		});

		const {
			clientType: clientTypeArr,
			subscription: subscriptionArr,
			archivePeriod: archivePeriodArr,
			safeLockingPeriod: safeLockingPeriodArr,
			liveChat: liveChatArr,
			mobile: mobileArr,
		} = organizedFilters;

		const _filteredClients = clients.filter((client) => {
			const isPersonalAccount = client.companyType === 0;
			const { subscription, archivePeriod, safeLockingPeriod, liveChat, mobile } = isPersonalAccount
				? client
				: client.company;

			if (isPersonalAccount && !clientTypeArr.includes(CLIENT_TYPES.length)) return false; // if it is personal account and "PP" is not chosen
			if (!isPersonalAccount && !checkIncludes(clientTypeArr, client.company.clientType))
				return false;
			if (
				!checkIncludes(subscriptionArr, subscription) ||
				!checkIncludes(archivePeriodArr, archivePeriod) ||
				!checkIncludes(safeLockingPeriodArr, safeLockingPeriod) ||
				!checkIncludes(liveChatArr, liveChat) ||
				!checkIncludes(mobileArr, mobile)
			)
				return false;

			return true;
		});

		return _filteredClients;
	}, [clients, filters]);

	const handleOpenFiltersModal = () => {
		setFilterModalVisible(true);
	};
	const handleCloseFiltersModal = () => {
		setFilterModalVisible(false);
	};

	const handleClearFilters = () => {
		setFilters(null);
	};
	const handleFilterSubmit = (newFilters) => {
		setFilters(newFilters);
	};

	const handleSearch = (event) => {
		event.preventDefault();
		const { value } = event.target;

		setSearchText((oldValue) => {
			const newValue = [value, true];
			// newValue[1] = true;
			return newValue;
		});
		// setSearchText((oldValue) => {
		// 	const newValue = [...oldValue];
		// 	newValue[1] = true;
		// 	return newValue;
		// });
	};

	const handleOpenNewClientModal = () => {
		setNewClientModalVisible(true);
	};

	const handleCloseNewClientModal = () => {
		setNewClientModalVisible(false);
	};

	return (
		<div className="clients-container route-container">
			<div className="flex flex--center-items gap-xxxl margin-s--bottom border--bottom">
				<p className="size600 w600 ">My Clients</p>
				<form className="flex size400">
					<input
						placeholder="Search"
						onChange={handleSearch}
						// onChange={({ target: { value } }) => {
						// 	setSearchText([value, false]);
						// }}
						value={searchText[0]}
					/>
					{/* <button type="submit" onClick={handleSearch}> */}
					<BsSearch />
					{/* </button> */}
				</form>
			</div>
			<div className="relative unselectable margin-xxl--right">
				<Table
					searchText={searchText}
					data={filteredClients}
					extraData={[1]}
					initialIndex={initialIndex}
				/>
				<div className="absolute flex gap-s margin-xxxl--right" style={{ top: "0.6rem", right: 0 }}>
					<button
						onClick={handleOpenNewClientModal}
						className={`size400 w500 border smooth-corners padding-l--inline`}
					>
						+ Add New Client
					</button>
					<button
						onClick={handleClearFilters}
						className={`size400 w500 border smooth-corners padding-l--inline ${
							!filterModalVisible && !filters && "selected"
						}`}
					>
						All
					</button>
					<button
						onClick={handleOpenFiltersModal}
						className={`size400 w500 border smooth-corners padding-l--inline ${
							(filterModalVisible || filters) && "selected"
						}`}
					>
						Filter
					</button>
				</div>
			</div>
			{filterModalVisible && (
				<FilterModal
					categories={Object.values(FILTER_CATEGORIES)}
					filters={filters}
					onClear={handleClearFilters}
					onFilter={handleFilterSubmit}
					dismiss={handleCloseFiltersModal}
				/>
			)}
			{newClientModalVisible && <NewClientModal dismiss={handleCloseNewClientModal} />}
		</div>
	);
};
export default Clients;
